import { IonContent, IonPage, useIonViewWillEnter } from "@ionic/react";
import React, { useContext, useEffect, useState, useCallback } from "react";

import {
  ICareerSheetAnswer,
  CareerChallengeSheet,
  CareerChallengeSheetFormData,
} from "../../../state";
import {
  Context,
  fetchCareerLatestSheet,
  fetchCareerSheets,
  fetchCareerChallengeSheet,
  createCareerChallengeSheets,
  createCareerChallengeTopics,
  saveCareerChallengeSheets,
  submitCareerChallengeSheets,
  saveCareerSheetAnswers,
  applyForCareerMapGeneration,
  clearSuccessMessage,
  clearErrorMessage,
  CREATE_CAREER_SHEETS_SUCCESS_MESSAGE,
  SAVE_CAREER_SHEET_ANSWERS_SUCCESS_MESSAGE,
  SAVE_CAREER_SHEET_ANSWERS_FAILURE_MESSAGE,
  APPLY_FOR_CAREER_MAP_GENERATION_SUCCESS_MESSAGE,
  APPLY_FOR_CAREER_MAP_GENERATION_FAILURE_MESSAGE,
  CREATE_CAREER_CHALLENGE_TOPICS_FAILURE_MESSAGE,
  CREATE_CAREER_CHALLENGE_TOPICS_SUCCESS_MESSAGE,
  SAVE_CAREER_CHALLENGE_SHEETS_SUCCESS_MESSAGE,
  SAVE_CAREER_CHALLENGE_SHEETS_FAILURE_MESSAGE,
  SUBMIT_CAREER_CHALLENGE_SHEETS_SUCCESS_MESSAGE,
  SUBMIT_CAREER_CHALLENGE_SHEETS_FAILURE_MESSAGE,
} from "../../../store/student";
import useToast from "../../../hooks/useToast";
import useWaitApiCall from "../../../hooks/useWaitApiCall";
import Toast from "../../../molecules/Toast";
import LoginHeader from "../../../organisms/LoginHeader";
import CareerSheet from "../../../templates/CareerSheet";
import styles from "../common.module.scss";

export const INITIAL_CAREER_CHALLENGE_SHEET_DATA: CareerChallengeSheet = {
  id: 0,
  term_no: 0,
  submitted_at: "",
  topics: [],
  futures: [],
  careers: [],
  hopes: [],
};

const CareerSheetPage = () => {
  const { contextState, dispatch } = useContext(Context);
  const [calling, peep] = useWaitApiCall(contextState);
  const { toast, setToast, handleToast } = useToast();

  const [isCreateTopicsFailed, setIsCreateTopicsFailed] = useState(false);

  useIonViewWillEnter(() => {
    if (contextState.career_latest_sheet?.term_no > 0) return;
    dispatch(fetchCareerLatestSheet());
    dispatch(fetchCareerSheets());
    dispatch(fetchCareerChallengeSheet());
  });

  useEffect(() => {
    if (contextState.success_message === CREATE_CAREER_SHEETS_SUCCESS_MESSAGE) {
      dispatch(fetchCareerLatestSheet());
      dispatch(fetchCareerSheets());
      dispatch(fetchCareerChallengeSheet());
    }
  }, [dispatch, contextState.success_message]);

  useEffect(() => {
    if (contextState.career_challenge_sheet_id) {
      dispatch(
        peep(
          createCareerChallengeTopics(contextState.career_challenge_sheet_id),
        ),
      );
      dispatch(fetchCareerChallengeSheet());
    }
  }, [dispatch, peep, contextState.career_challenge_sheet_id]);

  useEffect(() => {
    if (
      contextState.success_message ===
      CREATE_CAREER_CHALLENGE_TOPICS_SUCCESS_MESSAGE
    ) {
      dispatch(clearSuccessMessage());
      setIsCreateTopicsFailed(false);
    }
  }, [dispatch, contextState.success_message]);

  useEffect(() => {
    if (contextState.error === CREATE_CAREER_CHALLENGE_TOPICS_FAILURE_MESSAGE) {
      dispatch(clearErrorMessage());
      setIsCreateTopicsFailed(true);
    }
  }, [dispatch, contextState.error]);

  useEffect(() => {
    const successMessages = [
      SAVE_CAREER_SHEET_ANSWERS_SUCCESS_MESSAGE,
      APPLY_FOR_CAREER_MAP_GENERATION_SUCCESS_MESSAGE,
      SAVE_CAREER_CHALLENGE_SHEETS_SUCCESS_MESSAGE,
      SUBMIT_CAREER_CHALLENGE_SHEETS_SUCCESS_MESSAGE,
    ];
    const errorMessages = [
      SAVE_CAREER_SHEET_ANSWERS_FAILURE_MESSAGE,
      APPLY_FOR_CAREER_MAP_GENERATION_FAILURE_MESSAGE,
      SAVE_CAREER_CHALLENGE_SHEETS_FAILURE_MESSAGE,
      SUBMIT_CAREER_CHALLENGE_SHEETS_FAILURE_MESSAGE,
    ];

    handleToast("success", contextState.success_message, successMessages);
    handleToast("danger", contextState.error, errorMessages);
  }, [contextState.success_message, contextState.error, handleToast]);

  const saveCareerSheetAnswersFunc = useCallback(
    (id: number, answers: ICareerSheetAnswer[]) => {
      dispatch(saveCareerSheetAnswers(id, answers));
    },
    [dispatch],
  );

  const applyForCareerMapGenerationFunc = useCallback(
    (id: number) => {
      dispatch(applyForCareerMapGeneration(id));
    },
    [dispatch],
  );

  const fetchCareerChallengeSheetFunc = useCallback(() => {
    dispatch(fetchCareerChallengeSheet());
  }, [dispatch]);

  const createCareerChallengeSheetsFunc = useCallback(() => {
    dispatch(createCareerChallengeSheets());
  }, [dispatch]);

  const createCareerChallengeTopicsFunc = useCallback(
    (id: number) => {
      dispatch(peep(createCareerChallengeTopics(id)));
    },
    [dispatch, peep],
  );

  const saveCareerChallengeSheetsFunc = useCallback(
    (id: number, formData: CareerChallengeSheetFormData) => {
      dispatch(saveCareerChallengeSheets(id, formData));
    },
    [dispatch],
  );

  const submitCareerChallengeSheetsFunc = useCallback(
    (id: number, formData: CareerChallengeSheetFormData) => {
      dispatch(submitCareerChallengeSheets(id, formData));
    },
    [dispatch],
  );

  return (
    <IonPage>
      <Toast
        type={toast.type}
        showToast={toast.isShow}
        onClose={() => setToast({ ...toast, isShow: false })}
        message={toast.message}
      />
      <LoginHeader title="キャリア開拓モード" unreadNotiCount={0} />
      <IonContent className={styles.wrapper}>
        <div className={styles.container}>
          <CareerSheet
            calling={calling}
            isCreateTopicsFailed={isCreateTopicsFailed}
            saveCareerSheetAnswers={saveCareerSheetAnswersFunc}
            applyForCareerMapGeneration={applyForCareerMapGenerationFunc}
            fetchCareerChallengeSheet={fetchCareerChallengeSheetFunc}
            createCareerChallengeSheets={createCareerChallengeSheetsFunc}
            createCareerChallengeTopics={createCareerChallengeTopicsFunc}
            saveCareerChallengeSheets={saveCareerChallengeSheetsFunc}
            submitCareerChallengeSheets={submitCareerChallengeSheetsFunc}
          />
        </div>
      </IonContent>
    </IonPage>
  );
};

export default CareerSheetPage;
